export const COULD_NOT_FIND_TEXT = "We couldn't find";
export const DESCRIPTION_TEXT =
  'Please try searching for something else instead.';
export const NOT_ENOUGH_CHARACTERS = 'Please type at least 2 characters.';
export const BAD_SEARCH_INPUT =
  'Search term must be of type string and menu must be of type object';
export const SEARCH_LENGTH = 2;

// Fuse Search Params
export const SECTION_NAME_SEARCH_KEY = 'name';
export const PRODUCT_NAME_SEARCH_KEY = 'items.product.name';
export const PRODUCT_METADATA_TAGS_SEARCH_KEY = 'items.product.metadata_tags';
export const PRODUCT_MODIFIER_GROUP_SEARCH_KEY = 'items.modifierAndOptionNames';

const SEARCH_KEYS = [
  SECTION_NAME_SEARCH_KEY,
  PRODUCT_NAME_SEARCH_KEY,
  PRODUCT_METADATA_TAGS_SEARCH_KEY,
  PRODUCT_MODIFIER_GROUP_SEARCH_KEY
];

export const FUSE_OPTIONS = {
  // useExtendedSearch: false,
  ignoreLocation: true,
  // ignoreFieldNorm: false,
  // fieldNormWeight: 1,
  // findAllMatches: false,
  isCaseSensitive: false,
  includeScore: true,
  shouldSort: true,
  includeMatches: true,
  // Must match at least two chars
  minMatchCharLength: 2,
  // Where in the doc string do we want to match the input?
  // E.g. loc 0 and dist 5 means we start from the first char
  // and match up to 5 chars after
  location: 0,
  // How accurate the results should be
  threshold: 0.3,
  // How many characters from the location (first char)
  // do we allow typos
  distance: 5,
  keys: SEARCH_KEYS
};
